import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';
import { cx } from '../../utils/cx';
import styles from './Input.module.css';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  hint?: string;
  label?: string;
  leadingAdornment?: ReactNode;
  trailingAdornment?: ReactNode;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, error, hint, id, label, leadingAdornment, trailingAdornment, ...props },
  ref,
) {
  return (
    <label className={styles.field} htmlFor={id}>
      {(label || hint || error) && (
        <span className={styles.labelRow}>
          {label && <span className={styles.label}>{label}</span>}
          {error ? <span className={styles.error}>{error}</span> : hint ? <span className={styles.hint}>{hint}</span> : null}
        </span>
      )}
      <span className={cx(styles.control, error && styles.invalid, className)}>
        {leadingAdornment && <span className={styles.adornment}>{leadingAdornment}</span>}
        <input {...props} className={styles.input} id={id} ref={ref} />
        {trailingAdornment && <span className={styles.adornment}>{trailingAdornment}</span>}
      </span>
    </label>
  );
});
